export default __webpack_public_path__ + "static/media/selectedBarChartIcon.e7149264.svg";